<template>
    <div class="country-details">
        <div class="country-gabarit">
            <div class="right">
                <CloseCta class="close" @click="close"/>
            </div>

            <div class="content">
                <h2 v-if="data.country" v-html="data.country" class="title"></h2>
                <p v-if="bu.name" v-html="bu.name" class="name text"></p>

                <div v-if="bu.address" class="icon-text">
                    <IconPin :color="'#FFFFFF'" class="icon" width="12" height="16"/>
                    <p v-html="bu.address" class="address text"></p>
                </div>
                <div v-if="bu.phone" class="icon-text">
                    <IconPhone :color="'#FFFFFF'" class="icon" width="17" height="17"/>
                    <a :href="'tel:' + bu.phone" v-html="bu.phone" class="phone text"></a>
                </div>
                <div v-if="bu.emails && bu.emails.length > 0" class="icon-text">
                    <IconMail :color="'#FFFFFF'" class="icon icon-mail"/>
                    <ul class="mails text">
                        <li v-for="{ email } in bu.emails" :key="email" class="mail">
                            <a :href="'mailto:' + email" v-html="email"></a>
                        </li>
                    </ul>
                </div>
                <a
                    v-if="bu.link"
                    :href="bu.link"
                    v-html="bu.link.replace('http://', '').replace('https://', '')"
                    class="link"
                ></a>
            </div>
        </div>

    </div>
</template>
<script>
import CloseCta from '@/components/CloseCta'
import IconPin from '@/components/IconPin'
import IconMail from '@/components/IconMail'
import IconPhone from '@/components/IconPhone'
export default {
    components: {
        CloseCta,
        IconPin,
        IconMail,
        IconPhone
    },
    props: {
        data: {
            type: Object
        },
        bu: {
            type: Object
        }
    },
    data() {
        return { }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.country-details
    display: block
    color: #FFFFFF
    font-size: 15px
    overflow: hidden
    &.v-enter-active,
    &.v-leave-active
        transition: visibility .625s
        .country-gabarit
            transition: transform .625s cubic-bezier(.65,0,.25,1)
    &.v-enter,
    &.v-leave-to
        .country-gabarit
            transform: translateX(100%)
.country-gabarit
    width: 100%
    height: 100%
    padding-bottom: 65px
    background-color: #ff2b2a
a, p
    text-decoration: none
    font-weight: 500
    line-height: 1.2
li
    margin-bottom: 0.5em
.right
    text-align: right
    @include media-breakpoint-down($sm)
        padding-top: 75px
.close
    margin-left: auto
.content
    margin-left: 100px
    margin-right: 75px
    @include media-breakpoint-down($hd)
        margin-left: 9.6%
        margin-right: 9.6%

.icon-text
    position: relative
    margin-bottom: 35px
.icon
    position: absolute
    top: 0
    left: 0
    &.icon-mail
        margin-top: 2px
.title
    font-size: 30px
    font-weight: 500
    margin-bottom: 30px
    @include media-breakpoint-down($sm)
        font-size: 28px
.name
    font-size: 20px
    font-weight: 500
    text-transform: uppercase
    margin-bottom: 50px
    @include media-breakpoint-down($sm)
        font-size: 18px
.address, .phone, .mails
    margin-left: 38px
.mail
    text-decoration: none
    font-size: inherit
.link
</style>
